import { useEffect, useState, useCallback } from 'react';
import { useForm } from "react-hook-form";
import apiClient from "../../../utils/apiClient";
import FormSubmitButton from "../../forms/form-control/FormSubmitButton";
import FormInputDate from "../../forms/form-control/FormInputDate";
import {updateStateValue} from "../../../utils/stateHelpers";
import FormSelect from "../../forms/form-control/FormSelect";
import { useAuthenticate } from '../../../hooks/auth';

/**
 * Filter component
 * @returns {JSX.Element}
 * @constructor
 */
const ClientInvoicesFilters = (prop) => {
    const {register, getValues, handleSubmit, errors} = useForm();
    const {filters, setFilters, setTableData} = prop;
    const [clients, setClients] = useState([]);
    const [rigs, setRigs] = useState([]);
    const { user } = useAuthenticate();
    const CLIENT_GROUP_ID = 5;

    // get list of active clients
    useEffect(() => {
        apiClient
            .get('getActiveClientsList')
            .then(response => {
                setClients(
                    response.data.activeClientsList.map(
                        ({id, client_name}) => ({id: id, name: client_name})
                    )
                );
            });
    }, []);

    useEffect(() => {
        if (user?.group_id === CLIENT_GROUP_ID) {
            apiClient
                .post('getClientInvoiceRigs')
                .then(response => {
                    setRigs(
                        response.data.map(
                            ({id, name}) => ({id: id, name: name})
                        )
                    );
                });
        }
    }, [user])

    const getRigs = useCallback(() => {
        let clientId = getValues('client_id');

        if (clientId != null) {
            apiClient
                .post('getClientInvoiceRigs', {
                        client_id: clientId,
                    }
                )
                .then(response => {
                    setRigs(
                        response.data.map(
                            ({id, name}) => ({id: id, name: name})
                        )
                    );
                });
        } else {
            setRigs([]);
        }
    }, [getValues]);

    const onSubmit = (data) => {
        updateStateValue(setFilters, 'isLoading', true);
        updateStateValue(setFilters, 'isSubmitted', true);

        apiClient
            .post('getClientInvoices', data)
            .then(response => {
                if (Object.keys(response.data).length === 0) {
                    setTableData([]);
                    return;
                }
                setTableData(response.data);
            })
            .catch(function () {
                setTableData([]);
            }).then(function () {
            updateStateValue(setFilters, 'isLoading', false);
        });
    }

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row">
                {
                    (user?.group_id !== CLIENT_GROUP_ID) &&
                        <FormSelect
                            id="client_id"
                            label="Client"
                            className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                            options={clients}
                            onChange={getRigs}
                            register={register}
                        />
                }
                <FormInputDate
                    id="date_from"
                    label="Start Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_from}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputDate
                    id="date_to"
                    label="End Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_to}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSelect
                    id="rig_id"
                    label="Rig"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                    options={rigs}
                    register={register}
                />
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default ClientInvoicesFilters;
